// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const CONNECTOR_HEALTH_CHECK_METHODS = ['GET', 'HEAD'];
/** The instance `config` key a declared health check is resolved against. */
export const CONNECTOR_BASE_URL_CONFIG_KEY = 'base_url';
/**
 * Sprint 63.30.0 (#583) — the outcomes a finished sync is recorded with, in the
 * same vocabulary as {@link SyncHistoryStatus} (`running` is not an outcome).
 * `completeSync` read `'failed'`, a value outside this vocabulary, so a failed
 * sync was audited as completed.
 */
export const SYNC_OUTCOME_STATUSES = ['success', 'partial', 'failure'];
//# sourceMappingURL=connectors.js.map